import { render } from "./add-edit-algorithm.view.vue?vue&type=template&id=4fe036e2"
import script from "./add-edit-algorithm.view.vue?vue&type=script&lang=js"
export * from "./add-edit-algorithm.view.vue?vue&type=script&lang=js"

import "./add-edit-algorithm.view.vue?vue&type=style&index=0&id=4fe036e2&lang=css"

import exportComponent from "/mnt/ssd2/projects/techno2_remaster/client_ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__